import $ from 'jquery'
import {Core} from './core'

export class Sticky {

  constructor() {
    this.$body = $('body')
    this.$header = $('header')

    this.stickyClasses = {
      top: 'js-sticky-top',
      middle: 'js-sticky-middle',
      bottom: 'js-sticky-bottom'
    }

    this.stickyDatas = {
      bp: 'js-sticky-bp',
      mobile: 'js-sticky-mobile',
      desktop: 'js-sticky-desktop',
      parentTop: 'js-sticky-parent-top',
      parentBottom: 'js-sticky-parent-bottom',
      parentTopMobile: 'js-sticky-parent-top-mobile',
      parentBottomMobile: 'js-sticky-parent-bottom-mobile',
      middleWidthOffset: 'js-sticky-middle-width-offset',
      topOffsetDesktop: 'js-sticky-top-offset-desktop',
      topOffsetMobile: 'js-sticky-top-offset-mobile',
      fixHeightDesktop: 'js-sticky-fix-height-desktop',
    }

    this.submenuNavigationClass = 'submenu-navigation-content'
    this.$submenuNavigation = $(`.${this.submenuNavigationClass}`)

    this.bigSubmenuClass = 'big-submenu-content'
    this.$bigSubmenu = $(`.${this.bigSubmenuClass}`)

    this.bannerClass = 'banner-sticky'
    this.$banner = $(`.${this.bannerClass}:not(.single-reading-time-main *)`)

    $(document).on('ready', () => setTimeout(this.handleStickyNav.bind(this), 50))
    $(window).on('resize scroll', this.handleStickyNav.bind(this))
  }

  handleStickyNav(e) {
    $(`[data-${this.stickyDatas.mobile}], [data-${this.stickyDatas.desktop}]`).each(this.stickyNav.bind(this))
  }

  stickyNav(index, element) {
    if ( ! this.$header.length ) {
      return;
    }

    let $element = $(element)
    let scrollTop = $(window).scrollTop()
    let windowHeaderTop = this.$header.offset().top - scrollTop + this.$header.outerHeight(true) - 2

    if (!$element.hasClass(this.submenuNavigationClass) && this.$submenuNavigation.length > 0) {
      windowHeaderTop = this.$submenuNavigation.offset().top - scrollTop + this.$submenuNavigation.outerHeight(true)
    }

    if (!$element.hasClass(this.bigSubmenuClass) && this.$bigSubmenu.length > 0) {
      windowHeaderTop = this.$bigSubmenu.offset().top - scrollTop + this.$bigSubmenu.outerHeight(true)
    }

    if (!$element.hasClass(this.bigSubmenuClass) && !$element.hasClass(this.bannerClass) && this.$banner.length > 0) {
      windowHeaderTop = this.$banner.offset().top - scrollTop + this.$banner.outerHeight(true)
    }

    let scrollTopHeader = scrollTop + windowHeaderTop
    let stickyBp = $element.data(this.stickyDatas.bp)
    let stickyTopOffset = 0

    if (Core.isBpGreaterThan(stickyBp)) {
      if ($element.data(this.stickyDatas.desktop) === undefined) {
        this.resetClasses($element)
        return
      }

      if ($element.data(this.stickyDatas.topOffsetDesktop) !== undefined) {
        stickyTopOffset = $element.data(this.stickyDatas.topOffsetDesktop)
      }
    } else {
      if ($element.data(this.stickyDatas.mobile) === undefined) {
        this.resetClasses($element)
        return
      }

      if ($element.data(this.stickyDatas.topOffsetMobile) !== undefined) {
        stickyTopOffset = $element.data(this.stickyDatas.topOffsetMobile)
      }
    }

    windowHeaderTop += stickyTopOffset

    let $stickyParentTop = $element.parent()
    let $stickyParentBottom = $element.parent()

    if ($element.data(this.stickyDatas.parentTop) !== undefined) {
      $stickyParentTop = $($element.data(this.stickyDatas.parentTop))
    }

    if ($element.data(this.stickyDatas.parentBottom) !== undefined) {
      $stickyParentBottom = $($element.data(this.stickyDatas.parentBottom))
    }

    if (!Core.isBpGreaterThan(stickyBp)) {
      if ($element.data(this.stickyDatas.parentTopMobile) !== undefined) {
        $stickyParentTop = $($element.data(this.stickyDatas.parentTopMobile))
      }

      if ($element.data(this.stickyDatas.parentBottomMobile) !== undefined) {
        $stickyParentBottom = $($element.data(this.stickyDatas.parentBottomMobile))
      }
    }

    let stickyTop = $stickyParentTop.offset().top - stickyTopOffset
    let stickyBottom = $stickyParentBottom.offset().top + $stickyParentBottom.outerHeight(true) - $element.outerHeight(true) - stickyTopOffset

    $element.removeClass(this.stickyClasses.top)
    $element.removeClass(this.stickyClasses.middle)
    $element.removeClass(this.stickyClasses.bottom)

    $element.removeAttr('style')

    if (scrollTopHeader < stickyTop) {
      $element.addClass(this.stickyClasses.top).trigger('sticky:top')
    } else if (scrollTopHeader > stickyBottom) {
      $element.addClass(this.stickyClasses.bottom).trigger('sticky:bottom')
    } else {
      $element.css('top', windowHeaderTop)
      $element.css('left', $element.offset().left)

      if ($element.data(this.stickyDatas.middleWidthOffset) !== undefined) {
        $element.css('width', $element.outerWidth() + parseInt($element.data(this.stickyDatas.middleWidthOffset)))
      } else {
        $element.css('width', $element.outerWidth())
      }

      if (Core.isBpGreaterThan(stickyBp) && $element.data(this.stickyDatas.fixHeightDesktop) !== undefined) {
        const stickyHeight = Math.max(0, $(window).height() - windowHeaderTop)

        $element.css('height', stickyHeight)
        $element.css('max-height', stickyHeight)
      }

      $element.addClass(this.stickyClasses.middle).trigger('sticky:middle')
    }
  }

  resetClasses($element) {
    $element.removeClass(`${this.stickyClasses.top} ${this.stickyClasses.middle} ${this.stickyClasses.bottom}`)
    $element.removeAttr('style')
  }
}
